export class ReviewsCarousel {
  static selector = "[data-component=reviews-carousel]"

  constructor(el) {
    this.root = el
    this.reviewsData = JSON.parse(this.root.querySelector("script[type='application/json']").textContent)
    this.curIndex = 0
    this.imgRel = `reviews-${(Math.random() + 1).toString(36).substring(7)}`

    this.setupEventListeners()
    this.render()
  }

  changeReview = delta => {
    this.curIndex = (this.curIndex + delta) % this.reviewsData.length
    if (document.startViewTransition) {
      document.startViewTransition(this.render)
    } else {
      this.render()
    }

  }

  setupEventListeners = () => {
    for (const prevBtn of this.root.querySelectorAll('.btn--left')) {
      prevBtn.addEventListener("click", ev => {
        this.changeReview(this.reviewsData.length - 1)
        ev.target.blur()
      })
    }
    for (const nextBtn of this.root.querySelectorAll('.btn--right')) {
      nextBtn.addEventListener("click", ev => {
        this.changeReview(1)
        ev.target.blur()
      })
    }
  }

  render = () => {
    const review = this.reviewsData[this.curIndex]

    for (const el of this.root.querySelectorAll(".reviews-carousel__txt")) {
      el.querySelector("[data-field=name]").textContent = review.name
      el.querySelector("[data-field=tagline]").textContent = review.tagline
      el.querySelector("[data-field=quote]").textContent = `“${review.quote}”`
    }

    for (const el of this.root.querySelectorAll(".reviews-carousel__photos")) {
      const imgs = review.images.map(imgData => {
        const img = document.createElement("img")
        img.setAttribute("src", imgData.url)
        img.setAttribute("alt", imgData.alt)
        img.setAttribute("loading", "lazy")

        return img
      })

      el.replaceChildren(...imgs)
    }
  }
}
